import { useState } from "react";
import { Box } from "@mui/material";

// components
import { BasicSelect } from "../../ui/dropdown";
import { CollapsedBox } from "../../ui/collapsed-box";
import { TextFieldStr } from "../../ui/text-field";
import { usePlannerContext } from "../../../services/context/planner-context";
import { CheckboxPlanner } from "../../ui/checkbox-planner";

// constants
import { MAX_AREA_BUILDINGS } from "../../../constants/global.constants";
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";

export const Warehouse = ({ area, nodeId }) => {
  const { setNodes } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const formValues = area.building;

  const [displayTruckRequirement, setDisplayTruckRequirement] = useState(
    formValues.numDocks && formValues.numDocks > 0
  );

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mt: "16px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <TextFieldStr
          label={"min. Area"}
          unit="m²"
          placeholder="mandatory"
          name="rangeMin"
          requier={true}
          value={formValues.rangeMin}
          maxArea={formValues.rangeMax >= 0 ? formValues.rangeMax : null}
          setValue={handleValueChange}
          area={area}
          secondArea={formValues.rangeMax}
          shouldBeInteger={false}
          /* max={MAX_AREA_BUILDINGS} */
          min={100}
          tooltip={TEXT.planner.inputs.minAreaTooltip}
          disabled={viewOnly}
        />

        <TextFieldStr
          label={"max. Area"}
          unit="m²"
          placeholder="optional"
          name="rangeMax"
          value={formValues.rangeMax}
          minArea={formValues.rangeMin >= 0 ? formValues.rangeMin : null}
          setValue={handleValueChange}
          area={area}
          secondArea={formValues.rangeMin}
          shouldBeInteger={false}
          /* max={MAX_AREA_BUILDINGS} */
          min={100}
          tooltip={TEXT.planner.inputs.maxAreaTooltip}
          disabled={viewOnly}
        />
      </Box>

      <TextFieldStr
        label={"Docking Stations"}
        unit=""
        placeholder="optional"
        name="numDocks"
        value={formValues.numDocks}
        setValue={handleValueChange}
        area={area}
        shouldBeInteger={true}
        minArea={formValues.rangeMin}
        setDisplayTruckRequirement={setDisplayTruckRequirement}
        tooltip={TEXT.planner.inputs.dockingStationsTooltip}
        max={100}
        truckRequirement={formValues.truckRequirement === -1 ? 40 : formValues.truckRequirement}
        disabled={viewOnly}
      />

      {displayTruckRequirement ? (
        <BasicSelect
          label={"Truck Requirement"}
          unit={"t"}
          name="truckRequirement"
          placeholder="mandatory"
          requier={true}
          value={
            formValues.truckRequirement === -1 ? 40 : formValues.truckRequirement
          }
          setValue={handleValueChange}
          options={[3.5, 7.5, 18, 40]}
          area={area}
          tooltip={TEXT.planner.inputs.truckRequirementTooltip}
          disabled={viewOnly}
        />
      ) : null}

      <TextFieldStr
        label={"min. Inner Clearance Height"}
        unit="m"
        placeholder="optional"
        name="height"
        value={formValues.height}
        setValue={handleValueChange}
        area={area}
        tooltip={TEXT.planner.inputs.innerClearanceHeightTooltip}
        disabled={viewOnly}
      />

      <TextFieldStr
        label={"Cost per m²GFA"}
        unit="€/m²GFA"
        placeholder="optional"
        value={formValues.cost}
        name="cost"
        setValue={handleValueChange}
        area={area}
        tooltip={TEXT.planner.inputs.costTooltip}
        max={10000}
        disabled={viewOnly}
      />

      <CheckboxPlanner
        label={"Isolated"}
        value={formValues.isolated}
        setValue={handleValueChange}
        name="isolated"
        area={area}
        tooltip={TEXT.planner.inputs.isolatedTooltip}
        disabled={viewOnly}
      />
      {/* <CollapsedBox height={490}>//645
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <TextFieldStr
            label={"min. Inner Clearance Height"}
            unit="m"
            placeholder="optional"
            name="innerBuildHeight"
            value={formValues.innerBuildHeight}
            setValue={handleValueChange}
            area={area}
          />

          <TextFieldStr
            label={"Min. Clear Span"}
            unit="m"
            placeholder="optional"
            name="minClearSpan"
            value={formValues.minClearSpan}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
          />

          <BasicSelect
            label={"Docking Stations"}
            unit={""}
            name="numDocks"
            placeholder="optional"
            value={formValues.numDocks}
            setValue={handleValueChange}
            options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
            area={area}
          />

          <BasicSelect
            label={"Truck and Delivery Requirements"}
            unit={"t"}
            name="truckRequirement"
            placeholder="optional"
            value={formValues.truckRequirement}
            setValue={handleValueChange}
            options={[0, 3, 5, 7, 18, 40]}
            area={area}
          />

          <TextFieldStr
            label={"Cost per m²GFA"}
            unit="€/m²GFA"
            placeholder="optional"
            value={formValues.costGFA}
            name="costGFA"
            setValue={handleValueChange}
            area={area}
          />

          <TextFieldStr
            label={"No. of Employees"}
            unit=""
            placeholder="optional"
            name="numEmployees"
            value={formValues.numEmployees}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
          />

          <CheckboxPlanner
            label={"Isolated"}
            value={formValues.isolated}
            setValue={handleValueChange}
            name="isolated"
            area={area}
          />
        </Box>
      </CollapsedBox> */}
    </Box>
  );
};
